import { array, string, object } from 'yup'

export const TransactionExportSchema = object().shape({
  wantedFields: array().min(1, 'É necessário escolher pelo menos uma coluna.'),
  format: string().required('É necessário escolher o formato para exportação.'),
  emails: array()
    .min(1, 'É necessário pelo menos um e-mail.')
    .max(6, 'Você pode adicionar no máximo 6 e-mails.')
    .of(string().required('Preencha o e-mail.').email('E-mail inválido'))
})
